import { JsonProperty } from 'json-object-mapper';

export default class Guide {
  @JsonProperty()
  id = '';

  @JsonProperty({ name: 'guideName' })
  fullName = '';

  @JsonProperty({ name: 'alphaLearningLevels' })
  levels: string[] = [];
}
